import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/search.png'


const _withScopeId = n => (_pushScopeId("data-v-2258008e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-com" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"metting-wrap\" data-v-2258008e><span data-v-2258008e>中国共产党第20次代表大会</span></div><div class=\"hear-main\" data-v-2258008e><div class=\"content-box\" data-v-2258008e><img class=\"navtion-logo\" src=\"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.npc.gov.cn%2Fnpc%2Fkgfb%2F202101%2Fd8c025c904b94636a8e1799b652f86be%2Fimages%2Fbd02b85b8ad745b8aeaea2731daa91b7.png&amp;refer=http%3A%2F%2Fwww.npc.gov.cn&amp;app=2002&amp;size=f9999,10000&amp;q=a80&amp;n=0&amp;g=0n&amp;fmt=auto?sec=1672733124&amp;t=494c227a5008918e62e9be63454463f5\" alt=\"\" data-v-2258008e><div class=\"name\" data-v-2258008e>四川省人民政府驻厦门办事处</div><div class=\"e-name\" data-v-2258008e>Sichuan Provincial People&#39;s Government Office in Xiamen</div><div class=\"search-box\" data-v-2258008e><input type=\"text\" placeholder=\"请输入您想要搜索的内容\" data-v-2258008e><div class=\"button-wrap\" data-v-2258008e><span class=\"search\" data-v-2258008e>搜索</span><img class=\"searc-icon\" src=\"" + _imports_0 + "\" alt=\"\" data-v-2258008e></div></div></div></div>", 2)
const _hoisted_4 = { class: "header-nav" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["onClick"]

import { ref, reactive } from "vue";
import  {
  useRouter
}from"vue-router"

export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {

const navList: Array<String> = reactive([
  "首页",
  "首页",
  "首页",
  "首页",
  "首页",
  "首页",
  "首页",
  "首页",
  "首页"
]);
let currentNav: Number = ref(0);
const router=useRouter()
 console.log(11111)
const changeNav = (index: Number) => {
  console.log(11111)
  router.push("/newList")
  currentNav.value = index;
};
console.log(navList, "navList");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav-item", _unref(currentNav)==index?'activeNav':'']),
            onClick: ($event: any) => (changeNav(index)),
            key: index
          }, _toDisplayString(item), 11, _hoisted_6))
        }), 128))
      ])
    ])
  ]))
}
}

})